import React from 'react';
import Header from './Header';
import css from './login.css';

const ClientLayout = ({ children }) => {
    return (
        <div className={css.mt80}>
            <Header />
            { children }
        </div>
    )
}

export default ClientLayout;


// WEBPACK FOOTER //
// ./src/components/Portal/ClientLayout.js